/**
 * HOW TO USE:
 * ADD data-details ON PARENT AND data-details-item
 * ON DETAILS ELEMENT
 */
/**
 * Returns all detail items
 * @param details parent element of accordion
 * @returns {Element[]}
 */
var getDetailsItems = function (details) {
    return Array.from(details.querySelectorAll('[data-details-item]'));
};
/**
 * Iterates through all Detail Items and remove open
 * @param items
 * @param eventIndex
 */
var closeDetailsItems = function (items, eventIndex) {
    items.map(function (item, index) { return index !== eventIndex && item.removeAttribute('open'); });
};
/**
 * Iterates through detail items and
 * adds EventListener to close all others.
 * Self => default Event
 * @param details
 */
var detailsItemEvent = function (details) {
    var items = getDetailsItems(details);
    items.map(function (item, index) { return item.addEventListener('click', function () { return closeDetailsItems(items, index); }); });
};
/**
 * Collect all items to toggle
 * Execute Function
 * @returns {void}
 */
var ExecuteDetailToggleMechanism = function () {
    var details = Array.from(document.querySelectorAll('[data-details]'));
    if (details.length <= 0)
        return;
    details.map(function (details) { return detailsItemEvent(details); });
};
export default ExecuteDetailToggleMechanism;
